import React, { useState } from 'react';
import { Upload, message, Spin, Modal } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

type FileUploaderProps = {
    uploadUrl: string;
    btnName: string;
    setPriceListDetails: any;
    setPriceListDetailsSearch: any
};

const FileUploader: React.FC<FileUploaderProps> = ({ uploadUrl, btnName, setPriceListDetails, setPriceListDetailsSearch }) => {
    const { t } = useTranslation('common');
    const [uploading, setUploading] = useState<boolean>(false);

    const getToken = () => {
        return localStorage.getItem('accessToken');
    };

    const handleUpload = async (file: File) => {
        setUploading(true);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const res = await axios.post(uploadUrl, formData, {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    'Content-Type': 'multipart/form-data',
                },
            });

            // console.log('res', res.data.data)
            setPriceListDetails(res.data.data)
            setPriceListDetailsSearch(res.data.data)

            message.success('File uploaded successfully');
        } catch (error) {
            console.error('Error uploading file:', error);
            message.error('Error uploading file');
        } finally {
            setUploading(false);
        }
    };

    const customRequest = ({ file, onSuccess, onError }: any) => {
        setTimeout(() => {
            handleUpload(file);
            onSuccess();
        }, 0);
    };

    return (
        <>
            <Upload customRequest={customRequest} showUploadList={false}>
                <div onClick={() => { }}>
                    <UploadOutlined style={{ color: '#1677FF', fontSize: '20px', marginRight: '15px' }} />
                    {btnName}
                </div>
            </Upload>
            <Modal visible={uploading} title={t('uploading-file')} footer={null} closable={false} centered bodyStyle={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Spin size="large" />
            </Modal>
        </>
    );
};

export default FileUploader;
